<sc-flex vertical fitHeight stretchContent noFieldSpace>
  <sc-flex>
    <div class="item" (click)="back()"><sc-icon iconClass="fa-chevron-left"></sc-icon></div>
    <div class="item">{{selectedDate | date: 'dd.MM.yyyy'}}</div>
    <div class="item" (click)="forward()"><sc-icon iconClass="fa-chevron-right"></sc-icon></div>

    <sc-content-spacer></sc-content-spacer>
    <app-structure-node-selection (selectedStructureChanged)="onSelectedStructureChanged($event)"
      [selectedNode]="selectedStructureNode"></app-structure-node-selection>

    <sc-content-spacer grow></sc-content-spacer>

    <div class="item" [ngClass]="{'selected': isModeSelected('sums')}" (click)="selectMode('sums')">
      <sc-dictionary-label dictionaryKey="tmc-yard.ui.timeframe-usage.mode.sums"></sc-dictionary-label>
    </div>
    <sc-content-spacer></sc-content-spacer>
    <div class="item" [ngClass]="{'selected': isModeSelected('transports')}" (click)="selectMode('transports')">
      <sc-dictionary-label dictionaryKey="tmc-yard.ui.timeframe-usage.mode.transports"></sc-dictionary-label>
    </div>
    <sc-content-spacer></sc-content-spacer>
    <div class="item" [ngClass]="{'selected': isModeSelected('positions')}" (click)="selectMode('positions')">
      <sc-dictionary-label dictionaryKey="tmc-yard.ui.timeframe-usage.mode.positions"></sc-dictionary-label>
    </div>
  </sc-flex>

  <sc-content-spacer vertical double></sc-content-spacer>

  <sc-flex-fitting-content vertical>
    <sc-no-data-container [hasData]="relevantTimeframes?.length > 0" fitHeight>
    <sc-scroll-pane>
        <sc-items-grid [gap]="8" [width]="300">
          @for (tf of relevantTimeframes; track tf; let index = $index) {
          <yard-time-frame-usage-column [timeframes]="tf" [index]="index" [selectedTransportId]="selectedTransportId" (transportSelected)="onTransportClicked($event)"></yard-time-frame-usage-column>
          }
        </sc-items-grid>
      </sc-scroll-pane>
    </sc-no-data-container>
  </sc-flex-fitting-content>
</sc-flex>
